// extracted by mini-css-extract-plugin
module.exports = {"plus":"plus__2PnCo","entrance-fee":"entrance-fee__GP4DJ","label":"label__obV3g","price":"price__3c5Dh","price-no":"price-no__3aG16"};